const yt = {
  bn: () =>
    "serviceWorker" in navigator &&
    "undefined" != typeof ServiceWorkerRegistration &&
    "showNotification" in ServiceWorkerRegistration.prototype &&
    "PushManager" in window,
  mn: () =>
    "safari" in window &&
    "pushNotification" in window.safari &&
    "function" == typeof window.safari.pushNotification.permission &&
    "function" == typeof window.safari.pushNotification.requestPermission,
  isPushSupported: () => yt.bn() || yt.mn(),
  isPushBlocked: () => {
    const o =
        yt.isPushSupported() &&
        "Notification" in window &&
        null != window.Notification &&
        null != window.Notification.permission &&
        "denied" === window.Notification.permission,
      i =
        yt.isPushSupported() &&
        (!("Notification" in window) || null == window.Notification);
    return o || i;
  },
  isPushPermissionGranted: () =>
    yt.isPushSupported() &&
    "Notification" in window &&
    null != window.Notification &&
    null != window.Notification.permission &&
    "granted" === window.Notification.permission,
  Ui: () =>
    yt.isPushBlocked()
      ? { Vi: !1, reason: "blocked" }
      : yt.isPushSupported()
      ? yt.isPushPermissionGranted()
        ? { Vi: !1, reason: "permissionGranted" }
        : { Vi: !0 }
      : { Vi: !1, reason: "unsupported" },
  Wi: (o, i) =>
    "blocked" === o
      ? `${i} containing a push prompt is not being shown because the user has already declined push permission prompt.`
      : "unsupported" === o
      ? `${i} containing a push prompt is not being shown because the browser doesn't support push notifications.`
      : `${i} containing a push prompt is not being shown because the user has already accepted the permission prompt.`,
};
export default yt;
